import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles } from '@material-ui/core';
import { CloudDoneOutlined, CloseOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

const styles = () => ({
  uploadedIcon: {
    opacity: 0.7,
    fontSize: '2.5em',
    marginRight: 16,
    verticalAlign: 'middle'
  },
  selectedFileInfo: {
    display: 'inline-flex',
    flexDirection: 'column'
  }
});

const SelectedFile = ({ file, onRemove, classes }) => {
  const { t } = useTranslation();

  return (
    <div id='uploaded-file' style={{ display: 'block' }}>
      <CloudDoneOutlined className={classes.uploadedIcon} />
      <div className={classes.selectedFileInfo}>
        <div id='filename'>{file.name}</div>
        <div style={{ fontSize: '0.6rem' }}>
          {(file.size / 1024 / 1024).toFixed(2)} MB
        </div>
      </div>
      <IconButton
        title={t('dragAndDrop:remove')}
        size='small'
        style={{ marginTop: '-1rem' }}
        onClick={onRemove}
      >
        <CloseOutlined style={{ fontSize: '0.8rem' }} />
      </IconButton>
    </div>
  );
};

SelectedFile.propTypes = {
  file: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(SelectedFile);
